import { supabase } from "@/services/supabase/createClient";

export const getFirstWorkspace = async () => {
  const response = await supabase.rpc("get_personal_workspaces");
  return response.data?.[0].workspace_id || null;
};
